import { actionWithAppliedDate } from "./actionWithAppliedDate";
import rootActionTypes from "./rootActionTypes";

const rootOperations = {
  loadFile: (data, convertedFromV2) => {
    return actionWithAppliedDate({
      type: rootActionTypes.LOAD_FILE,
      data,
      convertedFromV2
    });
  },
  updateFile: data => {
    return actionWithAppliedDate({
      type: rootActionTypes.UPDATE_FILE,
      data
    });
  },
  loadSample: data => {
    return actionWithAppliedDate({
      type: rootActionTypes.LOAD_SAMPLE,
      data
    });
  },
  exportFileTsf: (
    attachmentPath,
    attachmentIds,
    disableFiltering,
    disableFilteringMore,
    disableSplitView,
    disableTimelineZoom,
    skin
  ) => {
    return {
      type: rootActionTypes.EXPORT_FILE_TSF,
      attachmentPath,
      attachmentIds,
      disableFiltering,
      disableFilteringMore,
      disableSplitView,
      disableTimelineZoom,
      skin
    };
  },
  exportFileCsv: (delimiter, typeIds, isSelectedItemsOnly) => {
    return {
      type: rootActionTypes.EXPORT_FILE_CSV,
      delimiter,
      typeIds,
      isSelectedItemsOnly
    };
  }
};

export default rootOperations;
